<template>
  <div class="unstaked-nft">
    <div class="d-flex flex-row justify-content-center unstaked-header">
      UNSTAKED
    </div>
    <div v-if="loading" class="d-flex flex-row justify-content-center">
      <img class="loading-gif" src="../assets/images/gifs/loading-fast.gif" alt="">
    </div>
    <div v-else class="d-flex flex-row justify-content-center position-relative">
      <div class="left-arrow">
        <button
          class="pagination-minus-unstaked-comp"
          v-if="unstakedNfts.length > 1"
          @click="decreasePage()"
        >
          &lt;
        </button>
      </div>
      <div class="d-flex justify-content-center unstaked-nfts">
        <div
          v-if="unstakedNfts.length > 0"
          class="nft-button-unstaked-comp windows-command-prompt"
          style="margin-top: -3px"
        >
          <button
            v-for="nft in unstakedNfts[unStakedIndex].pageInside[0]"
            :key="nft.id"
            @click="unstakedNFTclicked(nft)"
            :class="
              choosedToStakeNfts.find((p) => p.id == nft.id)
                ? 'choosen-ones'
                : ''
            "
          >
            <img
              class="nft-button-image"
              :src="nft.nftDetail.nft"
              :alt="nft.nftDetail.name"
            />
          </button>
        </div>
      </div>
      <div class="right-arrow">
        <button
          class="pagination-plus-unstaked-comp"
          v-if="unstakedNfts.length > 1"
          @click="increasePage()"
        >
          &gt;
        </button>
      </div>
       <button :disabled=loading class="reload-button" @click="refreshUnstakedNfts()">
        <img src="../assets/images/refresh-button.webp">
      </button>
      <div class="select-all-button" @click="selectAllNfts()">
        <input type="checkbox" v-model="selectAll" />
        <span class="select-all-span">Select all</span>
      </div>
    </div>
    <div v-if="!loading" class="d-flex flex-row justify-content-center stake-button-row">
      <button class="stake-button" @click="stakeClicked()">
        <div class="d-flex flex-row justify-content-center position-relative">
          <img
            class="stake-button-image"
            src="../assets/images/stake-button-bg.webp"
            alt=""
          />
          <span class="stake-button-text">stake</span>
        </div>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: ["unstakedNfts", "unstakedNftsWithoutPagination" , "loading"],
  data() {
    return {
      unStakedIndex: 0,
      choosedToStakeNfts: [],
      selectAll: false,
    };
  },
  methods: {
    selectAllNfts() {
      this.selectAll = !this.selectAll;
      if (this.selectAll) {
        for (let i = 0; i < this.unstakedNftsWithoutPagination.length; i++) {
          this.choosedToStakeNfts.push(this.unstakedNftsWithoutPagination[i]);
        }
      } else this.choosedToStakeNfts = [];
    },
    decreasePage() {
      this.unStakedIndex =
        this.unstakedNfts.length > 1 && this.unStakedIndex > 0
          ? (this.unStakedIndex -= 1)
          : this.unStakedIndex;
    },
    increasePage() {
      this.unStakedIndex =
        this.unStakedIndex < this.unstakedNfts.length - 1
          ? (this.unStakedIndex += 1)
          : this.unStakedIndex;
    },
    unstakedNFTclicked(nft) {
      const index = this.choosedToStakeNfts.findIndex((i) => i.id == nft.id);
      if (index > -1) {
        this.choosedToStakeNfts.splice(index, 1);
      } else {
        this.choosedToStakeNfts.push(nft);
      }
    },
    stakeClicked() {
      this.selectAll= false
      this.$emit("stakeClicked", this.choosedToStakeNfts);
    },
    refreshUnstakedNfts(){
      this.$emit("refreshUnstakedNft")
    }
  },
};
</script>

<style scoped>
.unstaked-nft {
  background-image: url("../assets/images/unstaked-new-parchment.webp");
  background-repeat: no-repeat;
  background-size: 507px 287px;
  width: 507px;
  height: 287px;
  margin: 0 auto;
}
.loading-gif{
  height: 155px;
}
.select-all-button {
  position: absolute;
  right: 95px;
  top: -20px;
  cursor: pointer;
}
.reload-button {
  position: absolute;
  left: 33px;
  top: -20px;
  cursor: pointer;
  background: none;
  border: none;
}
.reload-button img{
  width: 38px;
  height: 37px;
}
.select-all-span {
  position: absolute;
  left: 27px;
  top: 5px;
  font-size: 18px;
  text-align: center;
  line-height: 10px;
  color: #000;
}
.select-all-button input[type="checkbox"] {
  background-color: transparent;
}
.nft-button-image {
  width: 60px;
  height: 60px;
}
.nft-button-unstaked-comp button {
  padding: 0;
  background: none;
  border: 3px solid transparent;
  margin: 0 7px;
}
.pagination-minus-unstaked-comp {
  position: absolute;
  left: 73px;
  border: none;
  background: none;
  font-size: 30px;
  color: #000;
}
input[type="checkbox"] {
  position: relative;
  cursor: pointer;
}
input[type="checkbox"]:before {
  content: "";
  display: block;
  position: absolute;
  width: 23px;
  height: 23px;
  top: 0;
  left: 0;
  border: 2px solid #000;
  border-radius: 0;
  background-color: #e5c07f;
}
input[type="checkbox"]:checked:after {
  content: "";
  display: block;
  width: 10px;
  height: 20px;
  border: solid black;
  border-width: 0 2px 2px 0;
  -webkit-transform: rotate(35deg);
  -ms-transform: rotate(35deg);
  transform: rotate(35deg);
  position: absolute;
  top: 0;
  left: 6px;
}
.pagination-plus-unstaked-comp {
  border: none;
  background: none;
  font-size: 30px;
  position: absolute;
  right: 70px;
  color: #000;
}
.choosen-ones {
  border: 3px solid #ffd83a !important;
}
.stake-button {
  background: none;
  border: none;
}
.stake-button-row {
  margin-top: 20px;
}
.stake-button-text {
  color: #907242;
  position: absolute;
  font-size: 33px;
  height: 100%;
  height: 33px;
  line-height: 33px;
  top: 50%;
  transform: translateY(-50%);
  text-align: center;
}
.stake-button-text:hover {
  text-shadow: 1px 1px 20px #ead287, 1px 1px 20px #ead287, 1px 1px 20px #ead287,
    1px 1px 20px #ead287;
}
.close-button {
  position: absolute;
  background: none;
  border: none;
  top: 69px;
  right: 46px;
}
.stake-button-image {
  width: 182px;
  height: 42px;
}
.unstaked-header {
  font-size: 49px;
  color: black;
  line-height: 35px;
  margin-right: -7px;
  padding: 20px 0 20px 0;
}
.unstaked-nfts {
  width: 355px;
  height: 80px;
  margin-top: 35px;
}
.left-arrow {
  margin-top: 35px;
}
.right-arrow {
  margin-top: 35px;
}
@supports (-webkit-touch-callout: none) {
  .stake-button-text {
    font-size: 30px;
    line-height: 42px;
    height: 100%;
  }
}
@media (max-width: 1300px) {
  .unstaked-nft {
    background-size: 400px 200px;
    width: 400px;
    height: 200px;
  }
  .nft-button-image {
    width: 50px;
    height: 50px;
  }
  .loading-gif{
    height: 105px;
  }
  .reload-button img{
    width: 25px;
    height: 25px;
  }
  .unstaked-nfts {
    width: 300px;
    height: 50px;
    margin-top: 10px;
  }
  .pagination-minus-unstaked-comp {
    left: 40px !important;
  }
  .pagination-plus-unstaked-comp {
    right: 40px;
  }
  .left-arrow {
    margin-top: 10px;
  }
  .right-arrow {
    margin-top: 10px;
  }
  .select-all-span {
    position: absolute;
    left: 27px;
    top: 5px;
    font-size: 15px;
    text-align: center;
    line-height: 10px;
  }
  input[type="checkbox"]:before {
    width: 15px;
    height: 15px;
  }
  input[type="checkbox"]:checked:after {
    width: 5px;
    height: 10px;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
    top: 2px;
  }
  .unstaked-header {
    font-size: 32px;
    padding: 10px;
    margin-top: 0;
  }
}
@media (max-width: 769px) {
  .unstaked-nft {
    background-size: 300px 200px;
    width: 300px;
    height: 200px;
  }
  .unstaked-nfts {
    width: 200px;
    height: 50px;
    margin-top: 20px;
  }
  .reload-button{
    left: 20px;
    top: -15px;
  }
  .reload-button img{
    width: 20px;
    height: 20px;
  }
  .left-arrow {
    margin-top: 15px;
  }
  .pagination-minus-unstaked-comp {
    left: 20px !important;
  }
  .pagination-plus-unstaked-comp {
    right: 20px;
  }
  .right-arrow {
    margin-top: 15px;
  }
  .nft-button-image {
    width: 40px;
    height: 40px;
  }
  .select-all-button {
    right: 70px;
    top: -15px;
  }
  .select-all-span {
    position: absolute;
    left: 20px;
    top: 5px;
    font-size: 15px;
    text-align: center;
    line-height: 10px;
  }
  input[type="checkbox"]:before {
    width: 15px;
    height: 15px;
  }
  input[type="checkbox"]:checked:after {
    width: 5px;
    height: 10px;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
    top: 2px;
  }
  .unstaked-header {
    font-size: 32px;
  }
  .stake-button {
    margin-top: 6px;
  }
  .stake-button-image {
    width: 130px;
    height: 30px;
  }
  .stake-button-text {
    font-size: 20px;
    line-height: 25px;
    height: 30px;
  }
  @supports (-webkit-touch-callout: none) {
    .stake-button-text {
      font-size: 20px;
      line-height: 30px;
      height: 30px;
    }
  }
}
@media (max-width: 390px) {
  .unstaked-nfts {
    width: 220px;
  }
}
</style>